import React from 'react';
import { Phone, Mail, MessageCircle } from 'lucide-react';
import './Doctors.css';

const Doctors = () => {
  const doctors = [
    {
      name: 'Dr. Rajesh Sharma',
      specialty: 'Cardiologist',
      image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop&crop=face',
    },
    {
      name: 'Dr. Priya Gupta',
      specialty: 'Neurologist',
      image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&h=400&fit=crop&crop=face',
    },
    {
      name: 'Dr. Amit Verma',
      specialty: 'Orthopedic Surgeon',
      image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=400&h=400&fit=crop&crop=face',
    },
    {
      name: 'Dr. Sunita Patel',
      specialty: 'Pediatrician',
      image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=400&fit=crop&crop=face',
    },
  ];

  return (
    <div className="doctors-page">
      <section className="section">
        <div className="section-header">
          <h2>Meet Our Specialists</h2>
          <p>Dedicated professionals committed to your health and wellness</p>
        </div>
        <div className="doctors-grid">
          {doctors.map((doctor, i) => (
            <div className="doctor-card" key={i}>
              <div className="doctor-img-wrapper">
                <img className="doctor-img" src={doctor.image} alt={doctor.name} />
              </div>
              <div className="doctor-info">
                <h3>{doctor.name}</h3>
                <p>{doctor.specialty}</p>
                <div className="doctor-social">
                  <a href="tel:+917048944596" title="Call"><Phone size={16} /></a>
                  <a href="mailto:contact@rvtechnologies.net.in" title="Email"><Mail size={16} /></a>
                  <a
                    href={`https://web.whatsapp.com/send?phone=917048944596&text=Hello, I would like to consult with ${doctor.name} (${doctor.specialty}).`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="WhatsApp"
                  >
                    <MessageCircle size={16} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Doctors;
